import { makeStyles } from "@material-ui/core/styles";

const style = makeStyles((theme) => ({
  ABMEvents: {
    display: "flex",
    justifyContent: "space-between",
    height: "80%",
    width: "90%",
    position: "absolute",
  },
  ABMEventsForm: {
    height: "100%",
    width: "40%",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
    alignItems: "center",
  },
  ABMEventsTable: {
    height: "100%",
    width: "58%",
    overflow: "hidden",
  },
  ABMEventsTablePapper: {
    height: "100%",
    width: "58%",
    overflow: "hidden",
  },
  ABMEventsTableHeader: {
    display: "flex",
    alignItems: "center",
    padding: "10px",
    justifyContent: "space-between",
  },
  ABMEventsTableTitle: {
    marginRight: "10px",
  },
  ABMEventsAddTitle: {
    alignItems: "flex-end",
    display: "flex",
    alignSelf: "flex-start",
    width: "90%",
    justifyContent: "inherit",
  },
  input: {
    width: "80%",
    textAlign: "left",
  },
  button: {
    width: "80%",
  },
}));

export default style;
